<template>
  <div>
    <div class="customize_container">
      <div class="customize_title">
        <div class="step_title">選擇種類</div>
      </div>
      <div class="center">
        <div class="pic_pc" v-if="deviceWidth >= 768">
          <img
            v-for="(item, index) in goldWebImg"
            :key="index"
            :src="item.currentImage"
            @click="changeCustom(item.name, index)"
            @mouseover="item.currentImage = item.hoverImage"
            @mouseout="onMouseout(item.name, index)"
          />
        </div>
        <div class="pic_mobile" v-else>
          <img
            v-for="(item, index) in goldMobileImg"
            :key="index"
            :src="item.currentImage"
            @click="changeCustom(item.name, index)"
            @mouseover="item.currentImage = item.hoverImage"
            @mouseout="onMouseout(item.name, index)"
          />
        </div>
      </div>
      <StepPreNext :hidePreButton="true" @nextClick="nextStep"></StepPreNext>
    </div>
  </div>
</template>
<script>
import StepPreNext from "@/components/StepPreNext.vue";

// AA 系列 - 週歲鎖片
import webDefaultForAA from "@/images/customize-gift/aa-desktop-default.png";
import webHoverForAA from "@/images/customize-gift/aa-desktop-hover.png";
import mobileDefaultForAA from "@/images/customize-gift/aa-mobile-default.png";
import mobileHoverForAA from "@/images/customize-gift/aa-mobile-hover.png";

// AB 系列 - 週歲生日獎牌
import webDefaultForAB from "@/images/customize-gift/ab-desktop-default.png";
import webHoverForAB from "@/images/customize-gift/ab-desktop-hover.png";
import mobileDefaultForAB from "@/images/customize-gift/ab-mobile-default.png";
import mobileHoverForAB from "@/images/customize-gift/ab-mobile-hover.png";

// AC 系列 - 賀壽獎牌
import webDefaultForAC from "@/images/customize-gift/ac-desktop-default.png";
import webHoverForAC from "@/images/customize-gift/ac-desktop-hover.png";
import mobileDefaultForAC from "@/images/customize-gift/ac-mobile-default.png";
import mobileHoverForAC from "@/images/customize-gift/ac-mobile-hover.png";

// AV 系列 - 紀念車牌
import webDefaultForAV from "@/images/customize-gift/av-desktop-default.png";
import webHoverForAV from "@/images/customize-gift/av-desktop-hover.png";
import mobileDefaultForAV from "@/images/customize-gift/av-mobile-default.png";
import mobileHoverForAV from "@/images/customize-gift/av-mobile-hover.png";

// AW 系列 - 紀念門牌
import webDefaultForAW from "@/images/customize-gift/aw-desktop-default.png";
import webHoverForAW from "@/images/customize-gift/aw-desktop-hover.png";
import mobileDefaultForAW from "@/images/customize-gift/aw-mobile-default.png";
import mobileHoverForAW from "@/images/customize-gift/aw-mobile-hover.png";

// AX 系列 - 紀念獎牌
import webDefaultForAX from "@/images/customize-gift/ax-desktop-default.png";
import webHoverForAX from "@/images/customize-gift/ax-desktop-hover.png";
import mobileDefaultForAX from "@/images/customize-gift/ax-mobile-default.png";
import mobileHoverForAX from "@/images/customize-gift/ax-mobile-hover.png";

import { updateEngravingContent } from "@/utils/engravingContentHelper.js";

export default {
  name: "customizeGift",
  components: {
    StepPreNext,
  },
  created() {
    this.deviceWidth = window.innerWidth;
  },
  data() {
    return {
      deviceWidth: null,
      currentShape: null,
      goldWebImg: [
        {
          name: "週歲鎖片",
          currentImage: webDefaultForAA,
          defaultImage: webDefaultForAA,
          hoverImage: webHoverForAA,
        },
        {
          name: "週歲生日獎牌",
          currentImage: webDefaultForAB,
          defaultImage: webDefaultForAB,
          hoverImage: webHoverForAB,
        },
        {
          name: "賀壽獎牌",
          currentImage: webDefaultForAC,
          defaultImage: webDefaultForAC,
          hoverImage: webHoverForAC,
        },
        {
          name: "紀念車牌",
          currentImage: webDefaultForAV,
          defaultImage: webDefaultForAV,
          hoverImage: webHoverForAV,
        },
        {
          name: "紀念門牌",
          currentImage: webDefaultForAW,
          defaultImage: webDefaultForAW,
          hoverImage: webHoverForAW,
        },
        {
          name: "紀念獎牌",
          currentImage: webDefaultForAX,
          defaultImage: webDefaultForAX,
          hoverImage: webHoverForAX,
        },
      ],
      goldMobileImg: [
        {
          name: "週歲鎖片",
          currentImage: mobileDefaultForAA,
          defaultImage: mobileDefaultForAA,
          hoverImage: mobileHoverForAA,
        },
        {
          name: "週歲生日獎牌",
          currentImage: mobileDefaultForAB,
          defaultImage: mobileDefaultForAB,
          hoverImage: mobileHoverForAB,
        },
        {
          name: "賀壽獎牌",
          currentImage: mobileDefaultForAC,
          defaultImage: mobileDefaultForAC,
          hoverImage: mobileHoverForAC,
        },
        {
          name: "紀念車牌",
          currentImage: mobileDefaultForAV,
          defaultImage: mobileDefaultForAV,
          hoverImage: mobileHoverForAV,
        },
        {
          name: "紀念門牌",
          currentImage: mobileDefaultForAW,
          defaultImage: mobileDefaultForAW,
          hoverImage: mobileHoverForAW,
        },
        {
          name: "紀念獎牌",
          currentImage: mobileDefaultForAX,
          defaultImage: mobileDefaultForAX,
          hoverImage: mobileHoverForAX,
        },
      ],
    };
  },
  methods: {
    goToStep3(code) {
      const currentType =
        this.$store.getters.currentCustom.engraving_content.type;
      const currentContent =
        this.$store.getters.currentCustom.engraving_content.content;
      const metal = this.$store.getters.customizeMetalByComponentCode(code);
      this.$store.dispatch("updateCostom", {
        key: "shape",
        content: metal.shape,
      });
      this.$store.dispatch("updateCostom", {
        key: "style",
        content: metal.name,
      });
      this.$store.dispatch("updateCostom", {
        key: "accessory",
        content: metal.accessory[0],
      });
      updateEngravingContent(
        this.$store,
        metal.code,
        currentType,
        currentContent
      );
      this.$store.dispatch("updateComponentCode", metal.code);
      this.$router.push({ name: "customize_step3" });
    },
    changeCustom(itemName, index) {
      this.currentShape = itemName;

      // reset 圖片
      this.goldWebImg.forEach((item) => {
        item.currentImage = item.defaultImage;
      });
      this.goldMobileImg.forEach((item) => {
        item.currentImage = item.defaultImage;
      });

      // 顯示 hover 圖片
      this.goldWebImg[index].currentImage = this.goldWebImg[index].hoverImage;
      this.goldMobileImg[index].currentImage =
        this.goldMobileImg[index].hoverImage;
    },
    onMouseout(itemName, index) {
      if (itemName !== this.currentShape) {
        this.goldWebImg[index].currentImage =
          this.goldWebImg[index].defaultImage;
        this.goldMobileImg[index].currentImage =
          this.goldMobileImg[index].defaultImage;
      }
    },
    nextStep() {
      switch (this.currentShape) {
        case "週歲鎖片":
        default:
          this.goToStep3("AA");
          break;
        case "週歲生日獎牌":
          this.goToStep3("AB");
          break;
        case "賀壽獎牌":
          this.goToStep3("AC");
          break;
        case "紀念車牌":
          this.goToStep3("AV");
          break;
        case "紀念門牌":
          this.goToStep3("AW");
          break;
        case "紀念獎牌":
          this.goToStep3("AX");
          break;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.customize_container {
  position: relative; // 下一步按鈕定位用
  margin-top: 30px;
  padding-bottom: 60px;

  // 使用 ::v-deep 語法（Dart Sass 支援）
  ::v-deep .step-pre-next {
    top: 20vh;
    @include table {
      display: block;
      top: -5px;
    }
  }
}
.customize_title {
  color: $primaryDeepColor;
  font-size: 24px;
  font-family: "NotoSerifTC-Bold";
}
.center {
  z-index: 99;
  position: relative;
  margin-left: 20%;
  margin-right: 20%;
  @media all and (min-width: 1440px) {
    width: 864px;
    margin: auto;
  }
  @include table {
    z-index: 1;
    margin-top: 150px;
  }
  @include betweenPhoneTable {
    margin-left: 10%;
    margin-right: 10%;
  }
  @include phone {
    margin-left: 2%;
    margin-right: 2%;
  }
}
.pic_pc {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  img {
    width: 200px;
    height: 240px;
    padding: 10px;
  }
}
.pic_mobile {
  img {
    width: 90%;
  }
  img + img {
    margin-top: 10px;
  }
}
</style>
